/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_LabelInputs */

const en_svc_rag_label = /** @type {(inputs: Svc_Rag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG development`)
};

const lv_svc_rag_label = /** @type {(inputs: Svc_Rag_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RAG izstrāde`)
};

/**
* | output |
* | --- |
* | "RAG development" |
*
* @param {Svc_Rag_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_label = /** @type {((inputs?: Svc_Rag_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_label(inputs)
	return en_svc_rag_label(inputs)
});